module.exports = __webpack_public_path__ + "img/thumb.aef323f3.png";